module.exports = __webpack_public_path__ + "img/parth_nook.38420680.jpg";